import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.regexp.search.js";
import "core-js/modules/es6.regexp.split.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters, mapMutations, mapActions } from 'vuex';

var MdmSelect = () => import('~/components/atoms/MdmSelect.vue');

var SquareImage = () => import(
/* webpackChunkName: "square-image" */
'~/components/atoms/Product/SquareImage.vue');

export default {
  name: 'TheVariantsSection',
  components: {
    MdmSelect,
    SquareImage
  },
  props: {
    variants: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      truncated: true
    };
  },

  computed: _objectSpread(_objectSpread({}, mapGetters({
    locale: 'i18n/locale',
    sharedEnv: 'sharedEnv/getSharedEnv'
  })), {}, {
    maxCount() {
      return this.isDesktop() ? 5 : 8;
    }

  }),
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapMutations({
    setCurrentImage: 'product/SET_CURRENT_IMAGE',
    resetCurrentImage: 'product/RESET_CURRENT_IMAGE'
  })), mapActions({
    fetchProduct: 'product/fetchProduct'
  })), {}, {
    truncatedCount(count) {
      if (this.isMobile()) {
        return 0;
      }

      return count - this.maxCount;
    },

    truncatedCountMessage(count) {
      return this.$t(this.truncated ? 'show' : 'hide', {
        count: this.truncatedCount(count)
      });
    },

    fetch(reference, options) {
      var _this = this;

      return _asyncToGenerator(function* () {
        var args = {
          alias: reference,
          query: _this.$route.query,
          profileId: _this.$cookies.get('eb-profile') ? _this.$cookies.get('eb-profile').split(':')[0] : ''
        };
        yield _this.fetchProduct(args);

        if (window.history.replaceState) {
          var {
            slug
          } = options.find(option => option.reference === reference);
          var {
            search,
            hash
          } = window.location;
          var path = "".concat(slug, "-").concat(reference, ".htm").concat(search).concat(hash);
          window.history.replaceState('', '', path);
        }

        _this.$root.$emit('change-variant');
      })();
    },

    tracking(eventAction) {
      return {
        fn: 'track-event',
        data: {
          event_action: eventAction,
          event_category: 'FicheProduit',
          event_label: "".concat(window.tc_vars.product_activity, "/").concat(window.tc_vars.page_cat2, "/").concat(window.tc_vars.page_cat3, "/").concat(window.tc_vars.page_cat4, "/").concat(window.tc_vars.page_cat5)
        }
      };
    }

  })
};